/**
 * /unsubscribed?status=done|invalid&category=…
 *
 * Where the one-click unsubscribe link lands. The notifications-public
 * Edge Function acts on the signed token and redirects here; this page only
 * tells the person what happened, in their language. No session required:
 * the link has to work from any inbox.
 */
import { useTranslation } from 'react-i18next'
import { Link, useSearchParams } from 'react-router-dom'

export default function Unsubscribed() {
  const { t } = useTranslation()
  const [params] = useSearchParams()
  const done = params.get('status') === 'done'
  const category = params.get('category') ?? ''
  const categoryLabel = category
    ? t(`notifications.categories.${category}.label`, { defaultValue: category }).toLowerCase()
    : ''

  return (
    <div className="min-h-svh flex flex-col bg-[#FAF7F4]">
      <main className="flex-1 px-6 py-16 max-w-xl mx-auto w-full page-enter">
        <h1 className="font-display text-2xl mb-4" style={{ color: '#1C1128', fontWeight: 400 }}>
          {t('unsubscribe.title')}
        </h1>
        <p className="text-base mb-8" style={{ color: '#6B5F7A', lineHeight: 1.6 }}>
          {done ? t('unsubscribe.done', { category: categoryLabel }) : t('unsubscribe.invalid')}
        </p>
        <Link to="/profile" className="text-sm font-medium hover:opacity-70 transition-opacity" style={{ color: '#3D1F62' }}>
          {t('unsubscribe.manage')}
        </Link>
      </main>
    </div>
  )
}
